export default __webpack_public_path__ + "static/media/peluquerias.934918ce.png";